import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import { EmojiEvents } from "@mui/icons-material";
import { eventsCatalog } from "../data/songsData";
import { eventService } from "../services/eventService";

const EventsHomePage = () => {
  const navigate = useNavigate();
  const [events, setEvents] = React.useState(eventsCatalog);

  React.useEffect(() => {
    const unsubscribe = eventService.subscribeToPublishedEvents((items) => {
      if (items && items.length > 0) {
        setEvents(items);
      } else {
        setEvents(eventsCatalog);
      }
    });
    return () => unsubscribe && unsubscribe();
  }, []);

  return (
    <Box>
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography variant="h4" gutterBottom>
          Seleziona un evento
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Scegli l’evento per accedere a votazioni, scaletta e risultati.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {events.map((event) => (
          <Grid item xs={12} md={6} key={event.key}>
            <Card elevation={3}>
              <CardActionArea onClick={() => navigate(`/${event.key}`)}>
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <EmojiEvents color="primary" />
                      <Typography variant="h5">{event.title}</Typography>
                    </Box>
                    <Chip
                      label={
                        event.status === "published" ? "Disponibile" : "Bozza"
                      }
                      color={
                        event.status === "published" ? "success" : "default"
                      }
                      size="small"
                    />
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {event.subtitle}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EventsHomePage;
